import React, { PropsWithChildren, ReactNode } from 'react';
import { Modal, Paragraph } from '@wunder/ui-components';
import styles from '../../assets/scss/components/OverviewModal.module.scss';
import { Trans } from '@lingui/react/macro';

interface BookingOverviewModalT {
  modalFooter?: ReactNode;
  modalHeader?: ReactNode;
  displayFallback: boolean;
  onClose: () => void;
}

const OverviewModal: React.FC<PropsWithChildren<BookingOverviewModalT>> = ({
  modalFooter,
  modalHeader,
  children,
  displayFallback,
  onClose,
}) => {
  return (
    <Modal
      modalFooter={modalFooter}
      overlayClassName={styles['overview-modal__overlay']}
      modalHeader={modalHeader}
      contentClassName={
        displayFallback ? styles['overview-modal__no-results'] : styles['overview-modal__content']
      }
      className={styles['overview-modal']}
      innerModalClassName={styles['overview-modal__inner']}
      height="expand"
      align="right"
      variation="small"
      onClose={onClose}
      opened
    >
      {displayFallback ? (
        <Paragraph align="center" size={2} textColor="text-600">
          <Trans id="overviewModal.stationNotAvailable">Location not available.</Trans>
        </Paragraph>
      ) : (
        children
      )}
    </Modal>
  );
};

export default OverviewModal;
